export class InstrumentLookupProperties {
    constructor(instrumentLookupType, instruments, quickTree, filterStr) {
        this.instruments = [];
        // Only for Instrument dafaults???
        this.isInstrumentDefaults = false;
        this.existingInstrumentTypes = [];
        this.isOptionMaster = false;
        this.instrumentLookupType = instrumentLookupType;
        this.instruments = instruments;
        this.quickTree = quickTree;
        this.currentNameFilter = filterStr;
    }
}
export var InstrumentLookupType;
(function (InstrumentLookupType) {
    InstrumentLookupType[InstrumentLookupType["Big"] = 0] = "Big";
    InstrumentLookupType[InstrumentLookupType["Small"] = 1] = "Small";
})(InstrumentLookupType || (InstrumentLookupType = {}));
